export const SENSOR_TYPES = ['FRIDGE', 'ROOM'] as const

export type SensorType = (typeof SENSOR_TYPES)[number]
